import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useCollaboratorsPublicQuery } from '@/features/Collaborators/Data';
import { SI_PORTAL_BASE_PATH } from '../../siPortal.definitions';
import { publicacaoService } from '../publicacaoService';
import { PUBLICACOES_QUERY_KEYS } from '../usePublicacoes';
import type { Publicacao } from '../publicacao.types';

/** Quantas pessoas são cobradas: todos os ativos, ou a lista resolvida ao salvar. */
export function useTotalCobrados(publicacao: Publicacao): number {
  const { data: ativos = [] } = useCollaboratorsPublicQuery();
  return publicacao.ciencia.publico === 'todos' ? ativos.length : publicacao.ciencia.alvoIds.length;
}

/** "146 de 210 confirmaram" + barra — leva ao relatório de ciência. */
export function ProgressoCiencia({ publicacao }: { publicacao: Publicacao }) {
  const total = useTotalCobrados(publicacao);
  const { data: confirmaram } = useQuery({
    queryKey: [...PUBLICACOES_QUERY_KEYS.registros(publicacao.id, 'contagem'), publicacao.ciencia.versao],
    queryFn: () => publicacaoService.contarCiencias(publicacao.id, publicacao.ciencia.versao),
  });
  const percentual = total > 0 && confirmaram != null ? Math.min(100, Math.round((confirmaram / total) * 100)) : 0;

  return (
    <Link to={`${SI_PORTAL_BASE_PATH}/publicacoes/${publicacao.id}/ciencia`} className="block text-left md:text-right">
      <p className="text-sm font-semibold text-raro-gray-900">
        {confirmaram ?? '…'} de {total} confirmaram
      </p>
      <div className="mt-1 h-1.5 w-44 rounded-full bg-raro-gray-100 md:ml-auto">
        <div className="h-1.5 rounded-full bg-primary-600" style={{ width: `${percentual}%` }} />
      </div>
    </Link>
  );
}
